import { defineComponent, computed } from 'vue';
import { value2label, QUESTION_TYPE, numberToLetter, IS_QUESTION_TYPE_MULTI_CHOICE } from '@/utils';
import Image from './Image.vue';
import CustomAudio from './CustomAudio.vue';
export default defineComponent({
  name: 'QuestionChoice',
  components: {
    Image: Image,
    CustomAudio: CustomAudio
  },
  props: {
    question: {
      type: Object,
      default: function () {
        return {};
      }
    },
    answerMode: {
      type: Boolean,
      default: false
    },
    currentPaperAnswer: {
      type: String
    }
  },
  setup: function (props, _a) {
    var emit = _a.emit;
    var onOptionCheck = function (index, option) {
      if (props.answerMode) return;
      var answer = '';
      var question = props.question;
      if (IS_QUESTION_TYPE_MULTI_CHOICE(question.questionTypeId)) {
        option.checked = option.checked ? '' : 'checked';
        answer = question.options.map(function (o, i) {
          return {
            letter: numberToLetter(i),
            checked: o.checked
          };
        }).filter(function (o) {
          return o.checked;
        }).map(function (o) {
          return o.letter;
        }).join(',');
      } else {
        question.options.forEach(function (o) {
          return o.checked = '';
        });
        option.checked = 'checked';
        answer = numberToLetter(index);
      }
      emit('change', answer, question);
    };
    var isUserAnswerRight = computed(function () {
      return props.question.questionStatus === 'success';
    });
    return {
      value2label: value2label,
      QUESTION_TYPE: QUESTION_TYPE,
      numberToLetter: numberToLetter,
      onOptionCheck: onOptionCheck,
      isUserAnswerRight: isUserAnswerRight
    };
  }
});